import React, { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import SelectUserRoleForm from '../../components/SelectUserRoleForm/SelectUserRoleForm';

const CheckEmailToRegisterSuccessMessage = lazy(() =>
	import('../../components/Registration/CheckEmailToRegisterSuccessMessage')
);

const SelectedRoleStep1 = lazy(() =>
	import('../../components/Registration/SelectedRoleStep1')
);

const RegistrationSelectRole = () => (
	<SelectUserRoleForm initialSelectedRole="" />
);

const SelectRoleRegistrationRoutes = [
	{
		path: 'select-role',
		element: <Outlet />,
		children: [
			{
				index: true,
				element: <RegistrationSelectRole />,
			},
			{
				path: ':selected-user-role',
				element: (
					<Suspense fallback={<div>Loading...</div>}>
						<SelectedRoleStep1 />
					</Suspense>
				),
			},
			{
				path: 'check-email-to-register-success-message',
				element: (
					<Suspense fallback={<div>Loading...</div>}>
						<CheckEmailToRegisterSuccessMessage />
					</Suspense>
				),
			},
		],
	},
];

export default SelectRoleRegistrationRoutes;
